import { CustomSuspense } from "@/components/custom-suspense/custom-suspense";
import { lazy } from "react";
import type { RouteConfig } from "../models/types";

const DrawingsSearchPage = lazy(
	() => import("@/pages/drawings/search-documents"),
);
const DrawingsBrowserPage = lazy(
	() => import("@/pages/drawings/browser-documents"),
);

export const documentRoutes: RouteConfig[] = [
	{
		path: "/search-documents/*",
		element: (
			<CustomSuspense>
				<DrawingsSearchPage />
			</CustomSuspense>
		),
	},
	{
		path: "/browser-documents/*",
		element: (
			<CustomSuspense>
				<DrawingsBrowserPage />
			</CustomSuspense>
		),
	},
];
